import React from 'react';
import { DataFilterToolbar, type FilterDefinition } from '@/components/ui/DataFilterToolbar';

interface UserFilterBarProps {
  filters: Record<string, string>;
  onSearch: (val: string) => void;
  onFilterChange: (key: string, val: string) => void;
  actions?: React.ReactNode;
}

export function UserFilterBar({ filters, onSearch, onFilterChange, actions }: UserFilterBarProps) {
  const filterDefs: FilterDefinition[] = [
    {
      id: 'role_code',
      label: 'Tất cả vai trò',
      options: [
        { value: 'pm', label: 'Quản lý dự án' },
        { value: 'supervisor', label: 'Giám sát' },
        { value: 'technician', label: 'Kỹ thuật viên' },
        { value: 'staff', label: 'Nhân viên' },
      ]
    },
    {
      id: 'skill',
      label: 'Tất cả kỹ năng',
      options: [
        { value: 'Cắt tỉa', label: 'Cắt tỉa' },
        { value: 'Tưới tiêu', label: 'Tưới tiêu' },
        { value: 'Bón phân', label: 'Bón phân' },
        { value: 'Bảo trì máy', label: 'Bảo trì máy móc' },
      ]
    },
    {
      id: 'status',
      label: 'Tất cả trạng thái',
      options: [
        { value: 'active', label: 'Đang hoạt động' },
        { value: 'inactive', label: 'Tạm nghỉ/Đã nghỉ' },
      ]
    }
  ];

  return (
    <DataFilterToolbar
      search={filters.search || ''}
      onSearchChange={onSearch}
      searchPlaceholder="Tìm kiếm theo họ tên, mã nhân sự, SĐT..."
      filterDefs={filterDefs}
      filterValues={filters}
      onFilterChange={onFilterChange}
      actions={actions}
    />
  );
}
